/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RoleSelector_roles$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PrintableGovernanceForm_organization$ref: FragmentReference;
declare export opaque type PrintableGovernanceForm_organization$fragmentType: PrintableGovernanceForm_organization$ref;
export type PrintableGovernanceForm_organization = {|
  +id: string,
  +onRestrictedPlan: boolean,
  +isGoalsEnabled: boolean,
  +viewerIsAdminOrHigher: boolean,
  +isPdfReportGenerationRestricted: boolean,
  +customRoles: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +isDisplayedAsCircle: boolean,
        +name: string,
        +$fragmentRefs: RoleSelector_roles$ref,
      |}
    |}>
  |},
  +$refType: PrintableGovernanceForm_organization$ref,
|};
export type PrintableGovernanceForm_organization$data = PrintableGovernanceForm_organization;
export type PrintableGovernanceForm_organization$key = {
  +$data?: PrintableGovernanceForm_organization$data,
  +$fragmentRefs: PrintableGovernanceForm_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PrintableGovernanceForm_organization",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "onRestrictedPlan",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGoalsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerIsAdminOrHigher",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPdfReportGenerationRestricted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleConnection",
      "kind": "LinkedField",
      "name": "customRoles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDisplayedAsCircle",
                  "storageKey": null
                },
                {
                  "alias": "name",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "localizedName",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RoleSelector_roles"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '95722c8ffac1382dfde852a226a2c279';

module.exports = node;
